import type { RouteRecordRaw } from 'vue-router'

const shopRoutes: RouteRecordRaw[] = [
  {
    path: '/',
    component: () => import('@/layouts/app/layout-app.vue'),
    children: [
      {
        path: 'pembelian',
        children: [
          {
            path: '',
            name: 'purchase list',
            component: () => import('@/views/shop/purchase/list/page-purchase-list.vue'),
          },
          {
            path: 'retur',
            children: [
              {
                path: '',
                name: 'purchase retur list',
                component: () => import('@/views/shop/purchase/list/page-purchase-retur-list.vue'),
              },
              {
                path: 'buat',
                name: 'purchase retur create',
                component: () => import('@/views/shop/purchase/page-purchase-retur-create.vue'),
              },
              {
                path: 'buat-pembayaran',
                name: 'purchase payment retur create',
                component: () => import('@/views/shop/purchase/page-purchase-payment-retur-create.vue'),
              },
              {
                path: ':id',
                name: 'purchase retur detail',
                component: () => import('@/views/shop/purchase/detail/page-purchase-retur-detail.vue'),
              },

            ],
          },
          {
            path: 'buat',
            name: 'purchase create',
            component: () => import('@/views/shop/purchase/page-purchase-create.vue'),
          },
          {
            path: ':id',
            name: 'purchase detail',
            component: () => import('@/views/shop/purchase/detail/page-purchase-detail.vue'),
          },

          {
            path: 'pembayaran',
            children: [
              {
                path: '',
                name: 'purchase payment list',
                component: () => import('@/views/shop/purchase/list/page-purchase-payment-list.vue'),
              },
              {
                path: 'retur',
                name: 'purchase retur payment list',
                component: () => import('@/views/shop/purchase/list/page-purchase-retur-payment-list.vue'),
              },
            ],
          },
          {
            path: 'buat-pembayaran',
            name: 'purchase payment create',
            component: () => import('@/views/shop/purchase/page-purchase-payment-create.vue'),
          },
          {
            path: 'pembayaran/:id',
            name: 'purchase payment detail',
            component: () => import('@/views/shop/purchase/detail/page-purchase-payment-detail.vue'),
          },
          {
            path: 'pembayaran-retur/:id',
            name: 'purchase retur payment detail',
            component: () => import('@/views/shop/purchase/detail/page-purchase-retur-payment-detail.vue'),
          },
          {
            path: 'pembelianku',
            children: [
              {
                path: '',
                name: 'my purchase list',
                component: () => import('@/views/shop/my-purchase/list/page-my-purchase-list.vue'),
              },
            ],
          },

        ],
      },
      {
        path: 'penjualan',
        children: [
          {
            path: '',
            name: 'sale list',
            component: () => import('@/views/shop/sale/list/page-sale-list.vue'),
          },
          {
            path: ':id',
            name: 'sale detail',
            component: () => import('@/views/shop/sale/detail/page-sale-detail.vue'),
          },
          {
            path: 'harian',
            name: 'sale daily list',
            component: () => import('@/views/shop/sale/list/page-sale-daily-list.vue'),
          },
          {
            path: 'proses/:id',
            name: 'sale process',
            component: () => import('@/views/shop/sale/process/page-sale-process.vue'),
          },

        ],
      },
      {
        path: 'checkout',
        name: 'checkout',
        component: () => import('@/views/shop/checkout/page-checkout.vue'),
      },
      {
        path: 'toko-produk',
        children: [
          {
            path: 'produk-stock',
            children: [
              {
                path: '',
                name: 'product stock list',
                component: () => import('@/views/shop/product-stock/list/page-product-stock-list.vue'),
              },
            ],
          },
          {
            path: 'produk-kadaluarsa',
            name: 'product expiration list',
            component: () => import('@/views/shop/product-expiration/list/page-product-expiration-list.vue'),
          },
          {
            path: 'produk-kerusakan',
            children: [
              {
                path: '',
                name: 'product damage list',
                component: () => import('@/views/shop/product-damage/list/page-product-damage-list.vue'),
              },
              {
                path: ':id',
                name: 'product damage detail',
                component: () => import('@/views/shop/product-damage/detail/page-product-damage-detail.vue'),
              },
              {
                path: 'buat',
                name: 'product damage create',
                component: () => import('@/views/shop/product-damage/page-add-product-damage.vue'),
              },
            ],
          },
          {
            path: 'produk-stock-opname',
            children: [
              {
                path: '',
                name: 'stockopname list',
                component: () => import('@/views/shop/stock-opname/list/page-stockopname-list.vue'),
              },
              {
                path: ':id',
                name: 'stockopname detail',
                component: () => import('@/views/shop/stock-opname/detail/page-stockopname-detail.vue'),
              },
            ],
          },
        ],
      },
    ],
  },
]

export { shopRoutes }
